import { DateConstant } from '@unistocks/proxy/axios-client';
import { today, yesterday } from '@unistocks/shared/utils/util';
import { DateRange } from '@unistocks/types';
import { DateTime, FixedOffsetZone } from 'luxon';

export function getDateRange(period: DateConstant): DateRange {
  const todayDate = today();
  let from: DateTime = today();

  switch (period) {
    case DateConstant.OneDay:
      // Subtract one day
      from = yesterday();
      break;
    case DateConstant.OneWeek:
      // Subtract six days
      from = from.minus({ weeks: 1 }).plus({ days: 1 });
      break;
    case DateConstant.OneMonth:
      // Subtract one month, add one day
      from = from.minus({ months: 1 }).plus({ days: 1 });
      break;
    case DateConstant.ThreeMonths:
      // Subtract three months, add one day
      from = from.minus({ months: 3 }).plus({ days: 1 });
      break;
    case DateConstant.ThisYear:
      // Set date to january 1st of the same year
      from = from.startOf('year');
      break;
    case DateConstant.OneYear:
      // Subtract one year
      from = from.minus({ years: 1 });
      break;
    case DateConstant.ThreeYears:
      // Subtract three years
      from = from.minus({ years: 3 });
      break;
    case DateConstant.FiveYears:
      // Subtract five years
      from = from.minus({ years: 5 });
      break;
    case DateConstant.Max:
      // "Max" has no lower bound; callers treat the range start as open-ended
      from = null as unknown as DateTime;
      break;
  }

  return [from, todayDate];
}

export const UtcZone = FixedOffsetZone.utcInstance;
